import ListPhysicalCardDetailsUpdate from "./ListPhysicalCardDetailsUpdate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAtmDetails } from "../../../../../store/Api";
import nodeinstance from "../../../../../nodeInstance";

export default function PhysicalCardDetailsUpdate() {
  // const data = useSelector((state) => state.getAtmDetails);

  const [responseData, setResponseData] = useState();

  const getEmployeedData = async () => {
    try {
      const response = await nodeinstance.get(
        `/atm-payroll/PhysicalatmDetails`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setResponseData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    // dispatch(getAtmDetails(token));
    getEmployeedData();
  }, []);

  const updateData = () => {
    // dispatch(getAtmDetails(token));
    getEmployeedData();
  };

  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  return (
    <ListPhysicalCardDetailsUpdate
      titles={[
        "S.NO.",
        "EMPLOYEE ID",
        "EMPLOYEE NAME",
        "CLIENT",
        "VISA PROVIDER",
        "IQAMA NUMBER",
        "IQAMA EXPIRY DATE (G)",
        "IQAMA EXPIRY DATE (H)",
        "KSA CONTACT NUMBER",
        "ACCOUNT TO BE OPENED BY",
        "FEES",
        "PAYMENT STATUS",
        "BANK NAME",
        "ACCOUNT NUMBER",
        "IBAN NUMBER",
        "ATM CARD NUMBER",
        "ATM CARD EXPIRY",
        "PHYSICAL ATM CARD APPLIED DATE",
        "PHYSICAL ATM CARD RECEIVED DATE",
        "PHYSICAL ATM CARD STATUS",
      ]}
      list={responseData}
      loading={loading}
      token={token}
      updateData={updateData}
      uploadFile={setShowPromptElement}
    />
  );
}
